import React, { StrictMode, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Head from './module/Header';
import Main from './module/Main';
import Footer from './module/Footer';
import Aside from './module/Aside';
import SecSearchModal from './module/include/SecSearchModal';
import SecQuizPopup from './module/include/SecQuizPopup';
import TodayQuiz from './module/TodayQuiz';
import TodayCross from './module/TodayCross';
import TodaySearch from './module/TodaySearch';
import Search from './module/Search';
import WordList from './module/WordList';
import WordView from './module/WordView';
import My from './module/My';
import MyQuiz from './module/MyQuiz';
import MyCross from './module/MyCross';
import MySearch from './module/MySearch';
import MyZzim from './module/MyZzim';
import { CommonScriptLoader, ScrollToTop } from './module/include/Common';
  

const AsideWithLocation = () => {
  const location = useLocation();
  return <Aside location={location} />;
};
const HeadWithLocation = () => {
  const location = useLocation();
  return <Head location={location} />;
};
 
const Layout = () => {
  const location = useLocation();
  const [viewLoaded, setViewLoaded] = useState(false);

  const handleViewLoad = useCallback(() => {
    setViewLoaded(true);
  }, []);
  return (
    <>
      <ScrollToTop />
      <Head location={location} />
      <StrictMode>
        <CommonScriptLoader src={`https://code.asiae.co.kr/pocket/assets/js/common.min.js`} onLoadCallback={() => window.initCommonScript?.()} />
        <SecSearchModal pathname={location.pathname} /><></>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/Search" element={<Search />} onLoad={handleViewLoad} />
          <Route path="/Search/:stext" element={<Search />} onLoad={handleViewLoad} />
          <Route path="/WordList" element={<WordList />} />
          <Route path="/WordList/:stext" element={<WordList />} />
          <Route path="/View/:stext" element={<WordView />} onLoad={handleViewLoad} />
          <Route path="/Today" element={<TodayQuiz />} />
          <Route path="/TodayCross" element={<TodayCross />} />
          <Route path="/TodaySearch" element={<TodaySearch />} />
          <Route path="/My" element={<My />} onLoad={handleViewLoad} />
          <Route path="/MyQuiz" element={<MyQuiz />} onLoad={handleViewLoad} />
          <Route path="/MyCross" element={<MyCross />} onLoad={handleViewLoad} />
          <Route path="/MyQuiz/:stext" element={<MyQuiz />} onLoad={handleViewLoad} />
          <Route path="/MyCross/:stext" element={<MyCross />} onLoad={handleViewLoad} />
          <Route path="/MySearch" element={<MySearch />} onLoad={handleViewLoad} />
          <Route path="/MySearch/:stext" element={<MySearch />} onLoad={handleViewLoad} />
          <Route path="/MyZzim" element={<MyZzim />} />
        </Routes>
      </StrictMode>
      <SecQuizPopup />
      <Aside location={location} />
    </>
  );
};
const App = () => {

  return (
    <Router>
      <Layout />
    </Router>
  );
};
export default App;